// Platform roster for the "Listen Everywhere" section.
// icon = the export name inside react-icons (Simple Icons `Si*` or Font Awesome `Fa*`).
// Paste real profile/track URLs here; tiles with an empty url render as a disabled
// "Coming soon" state so nothing ever links to a dead 404.

export const STREAMING = [
  { name: "Amazon Music", icon: "FaAmazon", url: "" },
  { name: "Anghami", icon: "SiAnghami", url: "" },
  { name: "Apple Music", icon: "SiApplemusic", url: "" },
  { name: "Audiomack", icon: "SiAudiomack", url: "" },
  { name: "Bandcamp", icon: "SiBandcamp", url: "" },
  { name: "Boomplay", icon: "SiBoomplay", url: "" },
  { name: "Deezer", icon: "SiDeezer", url: "" },
  { name: "iHeartRadio", icon: "SiIheartradio", url: "" },
  { name: "iTunes Store", icon: "SiItunes", url: "" },
  { name: "Napster", icon: "SiNapster", url: "" },
  { name: "Pandora", icon: "SiPandora", url: "" },
  { name: "Qobuz", icon: "SiQobuz", url: "" },
  { name: "Shazam", icon: "SiShazam", url: "" },
  { name: "SoundCloud", icon: "SiSoundcloud", url: "" },
  { name: "Spotify", icon: "SiSpotify", url: "" },
  { name: "Tidal", icon: "SiTidal", url: "" },
  { name: "YouTube", icon: "SiYoutube", url: "" },
  { name: "YouTube Music", icon: "SiYoutubemusic", url: "" },
];

export const SOCIAL = [
  { name: "Facebook", icon: "SiFacebook", url: "" },
  { name: "Instagram", icon: "SiInstagram", url: "" },
  { name: "LinkedIn", icon: "FaLinkedinIn", url: "" },
  { name: "Pinterest", icon: "SiPinterest", url: "" },
  { name: "Snapchat", icon: "SiSnapchat", url: "" },
  { name: "Threads", icon: "SiThreads", url: "" },
  { name: "TikTok", icon: "SiTiktok", url: "" },
  { name: "Triller", icon: "SiTriller", url: "" },
  { name: "X (Twitter)", icon: "SiX", url: "" },
  { name: "YouTube", icon: "SiYoutube", url: "" },
];

// Primary smart-link (Linkfire / Feature.fm / Songwhip) and per-release pre-save slot.
export const SMART_LINK = "";
export const PRESAVE_LINK = "";

// Map release link keys -> display label + icon for the compact card platform rows.
export const LINK_META = {
  spotify: { name: "Spotify", icon: "SiSpotify" },
  appleMusic: { name: "Apple Music", icon: "SiApplemusic" },
  itunes: { name: "iTunes", icon: "SiItunes" },
  youtube: { name: "YouTube", icon: "SiYoutube" },
  youtubeMusic: { name: "YouTube Music", icon: "SiYoutubemusic" },
  amazonMusic: { name: "Amazon Music", icon: "FaAmazon" },
  tidal: { name: "Tidal", icon: "SiTidal" },
  deezer: { name: "Deezer", icon: "SiDeezer" },
  soundcloud: { name: "SoundCloud", icon: "SiSoundcloud" },
  audiomack: { name: "Audiomack", icon: "SiAudiomack" },
};
